/* eslint-disable */
/* tslint:disable */

import { pathgen } from 'object-path-generator';
import React from 'react';
const createProxyImpl = function (t
// eslint-disable-next-line @typescript-eslint/no-unsafe-call
) {
  if (t === void 0) {
    t = function () {
      for (var _len = arguments.length, _ref = new Array(_len), _key = 0; _key < _len; _key++) {
        _ref[_key] = arguments[_key];
      }
      let [k] = _ref;
      return k;
    };
  }
  return pathgen(undefined, function (path) {
    const finalPath = path.split('.$value')[0];
    for (var _len2 = arguments.length, options = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
      options[_key2 - 1] = arguments[_key2];
    }
    return t(finalPath, ...options);
  });
};
export function LocaleKeys(t) {
  return createProxyImpl(t);
}
const LocaleKeysContext = /*#__PURE__*/React.createContext({});
export const LocaleKeysProvider = _ref2 => {
  let {
    translateFn,
    localeKeys,
    children
  } = _ref2;
  if (!translateFn && !localeKeys) {
    throw new Error('Either translateFn or localeKeys must be provided');
  }
  const value = typeof translateFn === 'function' ? LocaleKeys(translateFn) : localeKeys;
  return /*#__PURE__*/React.createElement(LocaleKeysContext.Provider, {
    value: value
  }, children);
};
export const useLocaleKeys = () => React.useContext(LocaleKeysContext);
//# sourceMappingURL=LocaleKeys.js.map